<template>
  <div class="merp-page">
    <section class="banner-section">
      <div class="container">
        <div class="row">
          <div class="col-sm pt-5">
            <div class="pt-5">
              <h1>moneyMonit</h1>
              <p>Easily track your current balance on all your bank accounts, wallets including cash on hand.</p>
              <router-link to="/contact" class="btn btn-outline-secondary">Schedule a Demo</router-link>
              <a href="https://moneymonit.codehit.net" target="_blank" class="btn btn-outline-secondary ml-3">View App</a>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="pt-5">
              <a href="/img/money-monit.png" data-fancybox="money-monit-images">
                <div class="merp-banner">
                  <img src="/img/money-monit.png" alt="actMonit" class="img-fluid">
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <section>
        <h3 class="mt-5">Features</h3>
        <p>Stay updated on your current balance to better plan your financial spendings.</p>
        <div class="row">
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/money-monit/1.png" data-fancybox="money-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/money-monit/1.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/money-monit/1.png" data-fancybox="money-monit-images">
              <h3 class="h5 mb-1">Reports</h3>
            </a>
            <p class="text-muted">Monitor your budget expenses, get notified with over expenses.</p>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/money-monit/2.png" data-fancybox="money-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/money-monit/2.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/money-monit/2.png" data-fancybox="money-monit-images">
              <h3 class="h5 mb-1">Transactions</h3>
            </a>
            <p class="text-muted">Manage your transactions per account, category and date.</p>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/money-monit/3.png" data-fancybox="money-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/money-monit/3.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/money-monit/3.png" data-fancybox="money-monit-images">
              <h3 class="h5 mb-1">Accounts</h3>
            </a>
            <p class="text-muted">Manage your accounts and link them to your transactions.</p>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/money-monit/4.png" data-fancybox="money-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/money-monit/4.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/money-monit/4.png" data-fancybox="money-monit-images">
              <h3 class="h5 mb-1">Budgets</h3>
            </a>
            <p class="text-muted">Create your budgets, track multiple categories, set limits per category.</p>
          </div>
          <div class="col-sm-6 col-md-4 col-xl-3 mb-3">
            <div class="img-thumbnail mb-3">
              <a href="/img/money-monit/5.png" data-fancybox="money-monit-images">
                <div style="overflow:hidden;height:130px;" class="text-center">
                  <img src="/img/money-monit/5.png" alt="" class="img-fluid">
                </div>
              </a>
            </div>
            <a href="/img/money-monit/5.png" data-fancybox="money-monit-images">
              <h3 class="h5 mb-1">Categories</h3>
            </a>
            <p class="text-muted">Manage your transaction categories and use them to track your budgets.</p>
          </div>
        </div>
      </section>
    </div>
    <Footer/>
  </div>
</template>

<script>

import Footer from '@/components/Footer.vue'

export default {
  name: 'ActMonit',
  components: {
    Footer
  }
}
</script>

<style lang="scss">
  .banner-section {
    background:#f8f9fa url('/img/cityscape.png') no-repeat center bottom;
  }
  .merp-banner {
    overflow: hidden;
    height: 350px;
    text-align: center;
    box-shadow: -2px 2px 7px -1px rgba(0,0,0,0.2);
  }
</style>